<template lang="pug">
  .qr-menu

    .card
      .card-circle
      img.qr-code(src="~assets/ui/qroffical.jpg")
      //img.copy(src="~assets/ui/menu/qrcopy.png")
      .copy
        .line  长按二维码
        .line  关注加州旅游局公众号


</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power2, Circ} from 'gsap'
import IconClose from 'src/components/vca/widgets/IconClose'
//import Component from '@/components/Component'

export default {
  name: "QRPage",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    IconClose
  },
  data() {
    return {
    }
  },
  computed:{

  },
  methods: {
    init() {},

  },
  mounted() {
    this.init()

    //this.animateIn()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass">
  @import "src/styles/common.sass"
  .qr-menu
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    transform: translateX(100%)
    pointer-events: none
    top: 0
    left: 0
    opacity: 0
    position: absolute
    width: 100%
    height: 100%
    //background: #ffd81b

    //background: #ffd81b

     padding-left: 4rem

    //background: $cl-blue
    display: flex
    justify-content: center
    align-items: center
    .card

      width: 100%
      position: relative
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column
      .card-circle
        padding-top: 100%
        width: 100%
        height: auto
        border-radius: 50%
        position: absolute
        background: white
        z-index: 10
        transform-origin: center
        transform: scale(0.2)
        //transition-delay: 0.1s
        //transition-duration: 0.7s
        //transition-timing-function: ease-in-out
      .qr-code
        pointer-events: all
        display: block
        width: 45%
        z-index: 11

        transform-origin: center
        transform: scale(0)
        //transition-delay: 0.5s
        //transition-duration: 0.5s
        //transition-timing-function: ease-out
      //.copy
        width: 1.8rem
        z-index: 11
        text-align: center
        margin-top: 0.15rem
        display: block
        //.line
          font-size: $fs-s
          color: $cl-blue
      .copy
        text-align: center
        z-index: 11
        transform-origin: center
        transform: scale(0)
        //transition-delay: 0.7s
        //transition-duration: 0.3s
        //transition-timing-function: ease-out
        .line
          font-size: $fs-s
          color: $cl-blue
          line-height: $fs-s*1.5

    &.active
      transform: translateX(0)
      transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.3s
      opacity: 1
      .card-circle
        transform: scale(1.3)
        transition-delay: 0.4s
        transition-duration: 0.7s
        transition-timing-function: ease-in-out
      .qr-code
        transform: scale(1)
        transition-delay: 0.8s
        transition-duration: 0.4s
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)
      .copy
        transform: scale(1)
        transition-delay: 0.9s
        transition-duration: 0.3s
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)









</style>